export const ControllerTypes = {
    CONTROLLER_FETCH_START: 'controller/CONTROLLER_FETCH_START',
    CONTROLLER_FETCH_FINISH: 'controller/CONTROLLER_FETCH_FINISH',
    CONTROLLER_UPDATE_START: 'controller/CONTROLLER_UPDATE_START',
    CONTROLLER_UPDATE_FINISH: 'controller/CONTROLLER_UPDATE_FINISH',
};